import { Logger } from '@thesavingsgroup/logger/Logger';
import type { Reporter } from '@thesavingsgroup/reporting/types/Reporter';
import { isAxiosError, type AxiosResponse } from 'axios';

type ContentfulResponseLoggerDependencies = {
  logger?: Logger;
  reporter: Reporter;
};

export const contentfulResponseLogger =
  ({ reporter, logger = new Logger() }: ContentfulResponseLoggerDependencies) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (response: Error | AxiosResponse<any, any>): void => {
    logger.info('[REMOTE_CONFIGURATION_RESPONSE]', response);

    if (isAxiosError(response)) {
      reporter.error(
        new Error(`[REMOTE_CONFIGURATION_ERROR] ${response.message}`),
        {
          attachments: [
            {
              data: JSON.stringify(response.toJSON()),
              filename: 'response.json',
            },
            {
              data: JSON.stringify(response.request?.toJSON() || '{}'),
              filename: 'request.json',
            },
          ],
          originalException: response.cause ? response.cause : response,
        },
      );
    }

    if (response instanceof Error) {
      reporter.error(
        new Error(`[REMOTE_CONFIGURATION_ERROR] ${response.message}`),
        { originalException: response },
      );
    }
  };
